export class SearchPage {

  constructor(containerId = null) {
    this.containerNode = containerId ? document.getElementById(containerId) : null;

    if (!this.containerNode) {
      return;
    }

    if (this.containerNode) {
      this.initialBrands = this.containerNode.dataset.brands ? this.containerNode.dataset.brands.split(',') : [];
      this.initialSort = this.containerNode.dataset.sort || '';
      this.initialTerm = this.containerNode.dataset.term || '';
    } else {
      this.initialBrands = [];
      this.initialSort = '';
      this.initialTerm = '';
    }

    this.applyBrandFilters = this.applyBrandFilters.bind(this);
    this.applySort = this.applySort.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);

    this.init();
  }

  init() {
    const searchInput = this.containerNode.querySelector('input[name="search"]');
    if (searchInput && this.initialTerm) {
      searchInput.value = this.initialTerm;
    }

    document.querySelectorAll('input[name="brands"]').forEach(checkbox => {
      checkbox.addEventListener('change', this.applyBrandFilters);
    });

    document.querySelectorAll('input[name="sortByRadio"], #sortBy').forEach(input => {
      input.addEventListener('change', this.applySort);
    });

    this.initSearchForm();
    this.initMobileSearch();
    this.exposeFocusSearch();
  }

  applyBrandFilters() {
    const baseUrl = window.location.origin + window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.delete('page_no');

    const selectedBrands = Array.from(document.querySelectorAll('input[name="brands"]:checked'))
      .map(el => el.value);

    if (selectedBrands.length > 0) {
      params.set('brands', selectedBrands.join(','));
    } else {
      params.delete('brands');
    }

    const newUrl = baseUrl + (params.toString() ? '?' + params.toString() : '');
    if (newUrl !== window.location.href) {
      window.location.href = newUrl;
    }
  }

  applySort(event) {
    let baseUrl = window.location.origin + window.location.pathname;
    let params = new URLSearchParams(window.location.search);

    params.set('sort', event.target.value);

    let newUrl = baseUrl + (params.toString() ? '?' + params.toString() : '');
    window.location.href = newUrl;
  }

  // search form submit
  initSearchForm() {
    const searchForm = document.getElementById('searchResultsForm');
    if (!searchForm) return;

    searchForm.addEventListener('submit', this.handleSearchSubmit);
  }

  handleSearchSubmit(e) {
    e.preventDefault();

    const input = document.getElementById('searchResultsInput');
    const val = input?.value.trim();

    if (val && val.length > 0) {
      window.location.href = `/search/${encodeURIComponent(val)}/`;
    }
  }
  // focus on input on search icon click
  exposeFocusSearch() {
    window.focusSearch = () => {
      const container = document.getElementById('searchResultsForm');
      if (!container) return;

      const input = document.getElementById('searchResultsInput');
      if (!input) return;

      input.focus();
      const valLength = input.value.length;
      input.setSelectionRange(valLength, valLength);
    };
  }

  // mobile search
  initMobileSearch() {
    const mobileInput = document.getElementById('mobileSearchInput');
    if (!mobileInput) return;

    mobileInput.addEventListener('click', e => {
      e.preventDefault();

      const input = document.getElementById('searchResultsInput');
      if (input && document.activeElement !== input) {
        window.focusSearch();
      }
    });
  }
}